import React from 'react';
import { Link } from '@trussworks/react-uswds';

export function USWDSLink(props) {
  return <Link {...props} />;
}
